import { AnchorDirective } from './anchor.directive';
import { CarouselItemDirective } from './carousel-item.directive';
import { ClickOutsideDirective } from './click-outside.directive';

export const directives = [AnchorDirective, CarouselItemDirective, ClickOutsideDirective];

export * from './anchor.directive';
export * from './carousel-item.directive';
export * from './click-outside.directive';
